<template>
  <div class="section">
    <div class="container">
      <div class="block mb-4">
        <h1 class="title has-text-centered">Disclaimer</h1>
        <hr />
      </div>
      <div class="block">
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Inhalte allgemein</div>
            <div class="content">
              Die Goldmedia GmbH Strategy Consulting übernimmt keinerlei Gewähr
              für die Richtigkeit, Vollständigkeit und Aktualität der
              bereitgestellten Informationen. Haftungsansprüche gegen Goldmedia,
              welche sich auf Schäden jedweder Art beziehen, die durch die
              Nutzung oder Nichtnutzung der dargebotenen Informationen bzw.
              durch die Nutzung fehlerhafter und unvollständiger Informationen
              verursacht wurden, sind grundsätzlich ausgeschlossen, sofern auf
              Seiten von Goldmedia nicht nachweislich vorsätzliches oder grob
              fahrlässiges Verschulden vorliegt. Goldmedia behält es sich
              ausdrücklich vor, Teile der Seiten oder das gesamte
              Informationsangebot ohne gesonderte Ankündigung zu verändern, zu
              ergänzen, zu löschen oder die Veröffentlichung zeitweise oder
              endgültig einzustellen.
            </div>
          </div>
        </div>
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Verweise und Links</div>
            <div class="content">
              Bei direkten oder indirekten Verweisen auf fremde Internetseiten
              ("Links"), besteht eine Haftung von Goldmedia für dort befindliche
              Inhalte nur bei deren Kenntnis und für den Fall, dass es für
              Goldmedia auch technisch möglich und zumutbar wäre, die Nutzung im
              Falle rechtswidriger Inhalte zu verhindern. Goldmedia erklärt
              daher ausdrücklich, dass zum Zeitpunkt der Linksetzung die
              entsprechenden verlinkten Seiten frei von illegalen Inhalten
              waren. Goldmedia hat keinerlei Einfluss auf die aktuelle und
              zukünftige Gestaltung und auf die Inhalte der
              gelinkten/verknüpften Seiten. Deshalb distanziert sich Goldmedia
              hiermit ausdrücklich von allen Inhalten aller gelinkten
              /verknüpften Seiten, die nach der Linksetzung verändert wurden.
              Diese Feststellung gilt für alle innerhalb des eigenen
              Internetangebotes gesetzten Links und Verweise sowie für
              Fremdeinträge in gegebenenfalls von Goldmedia eingerichteten
              Gästebüchern, Diskussionsforen und Mailinglisten. Für illegale,
              fehlerhafte oder unvollständige Inhalte und insbesondere für
              Schäden, die aus der Nutzung oder Nichtnutzung solcherart
              dargebotener Informationen entstehen, haftet ausschließlich der
              Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige,
              der über Links auf die jeweilige Veröffentlichung lediglich
              verweist.
            </div>
          </div>
        </div>
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Keine Zusicherung oder Beratung</div>
            <div class="content">
              Die Informationen oder Daten auf den Websites stellen in keinem
              Fall rechtliche oder tatsächliche Zusicherungen dar, die eine
              direkte oder indirekte Schadensersatzpflicht auslösen können.
              Rechte und Pflichten zwischen uns und einem Nutzer der Websites
              oder Dritten entstehen und bestehen nicht. Durch den Abruf unserer
              Websites kommt auch kein Beratungsverhältnis zustande. Alle unsere
              Angebote auf unseren Websites sind in allen Teilen unverbindlich.
              Falls Sie eine Beratung durch uns wünschen oder eine unserer
              Dienstleistungen in Anspruch nehmen wollen, sprechen Sie uns bitte
              direkt und individuell an.
            </div>
          </div>
        </div>
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Urheber- und Kennzeichenrecht</div>
            <div class="content">
              Alle innerhalb des Internetangebotes genannten und ggf. durch
              Dritte geschützten Marken- und Warenzeichen unterliegen
              uneingeschränkt den Bestimmungen des jeweils gültigen
              Kennzeichenrechts und den Besitzrechten der jeweiligen
              eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist
              nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte
              Dritter geschützt sind. Alle veröffentlichten Texte, Bilder,
              Grafiken, Ton-, Video- und Animationsdateien sowie das Layout
              dieser Seiten unterliegen weltweitem Urheberrecht und anderen
              Gesetzen zum Schutz geistigen Eigentums. Sie dürfen weder für
              Handelszwecke oder zur Weitergabe kopiert, noch verändert und auf
              anderen Websites verwendet werden. Einige Seiten enthalten auch
              Bilder, die dem Urheberrecht derjenigen unterliegen, die diese zur
              Verfügung gestellt haben.
            </div>
          </div>
        </div>
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Datenschutz und vertrauliche Informationen</div>
            <div class="content">
              Sofern innerhalb des Internetangebotes die freiwillige Möglichkeit
              zur Eingabe persönlicher oder geschäftlicher Daten (z.B.
              Emailadressen, Namen, Anschriften) besteht, so werden diese Daten
              ausschließlich im Rahmen der Kontaktaufnahme oder für Rückfragen
              verwendet. Außerdem werden alle Anfragen oder Kommentare
              grundsätzlich diskret und vertraulich behandelt. Die
              Datenübertragung im Internet birgt (noch) Risiken. Verwenden Sie
              bei der Übersendung vertraulicher Informationen ein
              Verschlüsselungsprogramm wie z. B. PGP.
            </div>
          </div>
        </div>
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Rechtswirksamkeit</div>
            <div class="content">
              Die vorstehenden Klauseln sind als Teil des Internetangebotes zu
              betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern
              Teile oder einzelne Formulierungen dieses Textes der geltenden
              Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen
              sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt
              und ihrer Gültigkeit davon unberührt.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Disclaimer',
};
</script>
